<template>
    <div class="contact d-flex align-items-center justify-content-center">
        <div class="row d-flex flex-row contact-us-div">
            <div class="col-lg-6 col-12 company-logo">
                <img src="logo.webp" />
            </div>
            <div class="col-lg-6 col-12 contact-info-div text-white">
                <div class="row">
                    <div class="col-lg-12 col-sm-6 col-12">
                        <h2>Contact Us</h2>
                        <h4><a href="mailto:cacoates@sowellprepared.org">
                                <Mail />&nbsp;&nbsp;cacoates@sowellprepared.org
                            </a>
                        </h4>
                        <h4><a href="tel:+12147455569">
                                <PhoneCall />&nbsp;&nbsp;+1(214)745-5569
                            </a>
                        </h4>
                        <hr class="d-block d-sm-none d-lg-block">
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                        <h2>Business Hours</h2>
                        <h5>Monday - Friday: 11AM - 3PM CST</h5>
                        <h5>Saturday - Sunday: 6AM - 12PM CST</h5>
                        <hr class="d-block d-sm-none d-lg-block">
                    </div>
                </div>
                <hr class="d-none d-sm-block d-lg-none">
                <a class="router-link-appointment-contact" href="http://booking.sowellprepared.org">Make An
                    Appointment</a>
            </div>
        </div>
    </div>
</template>

<script>
import { Mail } from 'lucide-vue-next';
import { PhoneCall } from 'lucide-vue-next';

export default {
    name: 'ContactView',
    components: {
        Mail,
        PhoneCall
    }
}
</script>

<style>
hr {
    margin: 1.5rem 0;
    color: purple
}

.contact {
    padding: 2.5% 7.5%;
}

.contact-info-div {
    padding: 0 5%;
}

.contact-info-div a {
    color: #f6f0f0;
}

.contact-info-div h2 {
    color: #ffffff;
    font-weight: bold;
    text-align: left;
    font-size: 2.25rem;
    margin: 0.75rem 0;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    padding-top: 1rem;
}

.contact-us-div h5 {
    color: #f9efef;
    text-align: left;
    margin-top: 0.25rem;
    letter-spacing: 0.5px;
    font-weight: bolder;
    font-size: 1.55rem;
}

.contact-us-div h4 {
    font-size: 1.65rem;
}

.contact-us-div {
    background: #eca2c7;
    padding: 20px 20px;
    border-radius: 15px;
    width: 100%
}

.company-logo img {
    width: 97.5%;
    margin-left: 2.5%;
    border-radius: 12.5px
}

.router-link-appointment-contact {
    background: #66b2ff;
    color: white;
    text-decoration: none;
    padding: 0.75rem 1.25rem;
    font-size: 1.6rem;
    border-radius: 7.5px;
    width: 100% !important
}

@media(max-width: 1200px) and (min-width: 992px) {
    .contact-info-div h2 {
        font-size: 1.5rem;
        margin-top: 0.25rem
    }

    .contact-us-div h4 {
        font-size: 1.3rem;
    }

    .contact-us-div h5 {
        font-size: 1.25rem;
    }

    hr {
        margin: 1rem 0;
    }

    .router-link-appointment-contact {
        padding: 0.75rem 1.25rem;
        font-size: 1.45rem;
    }
}

@media(max-width: 992px) and (min-width: 768px) {
    .company-logo img {
        width: 60%;
        margin-left: 20%;
        border-radius: 12.5px
    }

    .contact-info-div h2 {
        font-size: 1.45rem;
    }

    .contact-us-div h4 {
        font-size: 1.1rem;
    }

    .contact-us-div h5 {
        font-size: 0.95rem;
    }

    hr {
        margin: 1.25rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.5rem;
        font-size: 1.25rem;
        border-radius: 5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 20px;
        height: 20px
    }
}

@media(max-width: 768px) and (min-width: 576px) {
    .company-logo img {
        width: 60%;
        margin-left: 20%;
        border-radius: 12.5px
    }

    .contact-info-div h2 {
        font-size: 1.1rem;
    }

    .contact-us-div h4 {
        font-size: 0.76rem;
    }

    .contact-us-div h5 {
        font-size: 0.675rem;
    }

    hr {
        margin: 1rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.2rem;
        font-size: 1rem;
        border-radius: 3.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 17.5px;
        height: 17.5px
    }
}

@media(max-width: 576px) and (min-width: 420px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.3rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 1.15rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 1.05rem;
        text-align: center;
    }

    hr {
        margin: 1.25rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.5rem;
        font-size: 1.15rem;
        border-radius: 7.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 20px;
        height: 20px
    }

    .contact {
        padding: 7.5% 7.5%;
    }
}

@media(max-width: 420px) and (min-width: 360px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.3rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 1.0125rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 0.925rem;
        text-align: center;
    }

    .contact {
        padding: 0 3.5%;
    }

    hr {
        margin: 0.75rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.4rem;
        font-size: 1.15rem;
        border-radius: 7.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 15.5px;
        height: 15.5px
    }

    .contact {
        padding: 7.5% 7.5%;
    }
}

@media(max-width: 360px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.15rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 0.95rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 0.85rem;
        text-align: center;
    }

    .contact {
        padding: 0 3.5%;
    }

    hr {
        margin: 0.75rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.3rem;
        font-size: 1rem;
        border-radius: 5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 13.5px;
        height: 13.5px
    }

    .contact {
        padding: 7.5% 7.5%;
    }
}
</style>